import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CurrentPlatform } from '../../enums';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-user-agreement-modal',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './user-agreement-modal.component.html',
  styleUrls: ['./user-agreement-modal.component.scss'],
})
export class UserAgreementModalComponent {
  @Input() platform: CurrentPlatform | null = null;

  @Output() accepted = new EventEmitter<void>();

  accept(): void {
    this.accepted.emit();
  }
}
